import Vue from "vue";
import VueResource from "vue-resource";
import AsyncComputed from "vue-async-computed";

import ApiAuth from "../models/ApiAuth.js";
import PricingMode from "../models/PricingMode.js";
import DrugSearch from "../models/DrugSearch.js";
import MedicationMonograph from "../models/MedicationMonograph.js";
import Announcement from "../models/Announcement.js";
import Account from "../models/Account.js";
import InteractionInformation from "../components/InteractionInformation.vue";
import MedicationLabelResource from "../models/MedicationLabelResource.js";
import CabinetResource from "../models/CabinetResource.js";
import CabinetForm from "../components/CabinetForm.vue";
import Benefit from "../models/Benefit.js";
import UmRequirement from "../models/UmRequirement.js";
import ProTip from "../components/ProTip.vue"
import MedicationInformation from "../components/MedicationInformation.vue";
import RxeobAutocomplete from "../components/RxeobAutocomplete.vue";
import RxeobDrugSearchAutocomplete from "../components/RxeobDrugSearchAutocomplete.vue";
import debounce from 'lodash/debounce';
import _ from 'lodash';
import Buefy from 'buefy';
import BCollapsebottom from "../components/CollapseBottom.vue";
import DrugSearchTable from "../components/DrugSearchTable.vue";
import PublicDrugSearchTable from "../components/PublicDrugSearchTable.vue";
import SlideOut from "../components/SlideOut.vue";
import globalStore from '../models/variables.js';
import Default from "../models/Default.js";
import axios from "axios";


Vue.use(Buefy);
Vue.use(VueResource);
/***************************************/

// add to all vue-resource request headers
var headers = {
    Accept: "application/json"
};
ApiAuth.addAuthHeader(headers);

for (var k in headers) {
    Vue.http.headers.common[k] = headers[k];
}

// add headers to model requests
PricingMode.initializeHeaders(headers);
MedicationMonograph.initializeHeaders(headers);
Benefit.initializeHeaders(headers);
Account.initializeHeaders(headers);
Announcement.initializeHeaders(headers);
UmRequirement.initializeHeaders(headers);
Default.initializeHeaders(headers);

// create the app
Vue.use(AsyncComputed);
var app = new Vue({
    el: "#drug-search-app",
    components: {
        RxeobAutocomplete: RxeobAutocomplete,
        RxeobDrugSearchAutocomplete: RxeobDrugSearchAutocomplete,
        ProTip: ProTip,
        CabinetForm: CabinetForm,
        MedicationInformation: MedicationInformation,
        BCollapsebottom: BCollapsebottom,
        DrugSearchTable: DrugSearchTable,
        PublicDrugSearchTable: PublicDrugSearchTable,
        SlideOut: SlideOut
    },
    methods: {

        /*
         * setEmulationStatus is a function that will set the variable isEmulated to true if the primary person id and the current person id is not equal
         * This variable will be used to show/hide the add to cabinet button.
         */
        setEmulationStatus: function () {
            var me = this;

            const loadingComponent = this.$buefy.loading.open({
                container: true ? null : me.$refs.element.$el
            })
            Account.get().then(function (response) {
                me.primaryPersonId = response.data.PrimaryEligibility.PersonId;
                Account.getCurrentPerson().then(function (response) {
                    me.currentHealthPlanId = response.data.HealthPlanId;
                    me.currentPersonId = response.data.PersonId;
                    if (me.primaryPersonId != me.currentPersonId) {
                        console.log("here")
                        me.isEmulated = true;
                        me.RxWalletSSO = false;
                    } else if (me.RxWalletSSO == true) {
                        me.TrueRxWalletSSO = true;
                    }
                    loadingComponent.close();
                }).catch(function (error) {
                    console.log(error);
                    loadingComponent.close();
                });
            }).catch(function (error) {
                console.log(error);
                loadingComponent.close();
            });
        },

        loadDefaults: function () {
            var me = this;
            Default.GetForView("drug_lookup").then(function (res) {
                me.defaults = res.data;
                me.loadText();

            });

            Default.GetForView("drug_lookup_table").then(function (res) {
                me.tableDefaults = res.data;
                console.log("Table", me.tableDefaults);
            });

        },
        getCheckPrice: function (healthplan) {
            if (healthplan == 31 || healthplan == 74 || healthplan == 76) {
                this.checkPriceFlag = true
            }
        },
        getRxWalletSSO: function (RxWallet) {
            if (RxWallet == "True") {
                this.RxWalletSSO = true;
            }
        },

        getDefault: function (nameKey) {
            return Default.Find(nameKey, this.defaults);
        },
        loadText: function () {
            this.searchPlaceholderText = this.getDefault("search_placeholder");
            this.searchButtonText = this.getDefault("search");
            this.clearButtonText = this.getDefault("clear");
            this.noResultsText = this.getDefault("no_results");
            this.pageText = this.getDefault("page");
            this.nextPageText = this.getDefault("next_page");
            this.previoiusPageText = this.getDefault("previous_page");
            this.currentPageText = this.getDefault("current_page");
            this.dateFormat = this.getDefault("date_format");
            this.dateText = this.getDefault("date");
            this.medicationText = this.getDefault("medication");
            this.copayText = this.getDefault("copay");
            this.proTipText = this.getDefault("pro_tip");
            this.proTipMessageText = this.getDefault("pro_tip_msg");
            this.selectMonthText = this.getDefault("select_month");
            this.datePlaceholderText = this.getDefault("date_placeholder");
            this.selectBeginText = this.getDefault("select_begin");
            this.selectEndText = this.getDefault("select_end");
            this.daysSupplyUpToText = this.getDefault("days_supply_up_to");
            this.coveredOnlyText = this.getDefault("covered_only");
            this.genericsOnlyText = this.getDefault("generics_only");
            this.benefitOnlyText = this.getDefault("benefit_info");
            this.indicatorsText = this.getDefault("indicators");
            this.quantityText = this.getDefault("quantity");
            this.quantityDesc1Text = this.getDefault("quantity_desc_1");
            this.quantityDesc2Text = this.getDefault("quantity_desc_2");
            this.quantityDesc3Text = this.getDefault("quantity_desc_3");
            this.alternativesInformationText = this.getDefault("alternatives_information");
            this.addCabinetText = this.getDefault("add_cabinet");
            this.medInfoText = this.getDefault("med_info");
            this.resultDetailText = this.getDefault("result_detail");
            this.disclaimerText = this.getDefault("disclaimer");
            this.searchTimeoutErrorText = this.getDefault("search_timeout_error");
            this.searchUnknownErrorText = this.getDefault("search_unknown_error");
            this.proTipText = this.getDefault("pro_tip");
            this.proTipMessageText = this.getDefault("pro_tip_message");
            this.allowedAmountText = this.getDefault("allowed_amount");
            this.quantityLinkText = this.getDefault("quantity_link");
            this.maintenanceText = this.getDefault("maintenance_text");
            this.checkPharmacyText = this.getDefault("check_pharmacy_text");
            this.proTipPublicText = this.getDefault("public_pro_tip");
            this.proTipPublicMessageText = this.getDefault("public_pro_tip_message");
            this.planPaidText = this.getDefault("plan_paid");
            this.CoDisclaimerModalTitleText = this.getDefault("CodisclaimerTitle");
            this.CoDisclaimerModalMessageText = this.getDefault("CodisclaimerBody");
            this.CoDisclaimerModalButtonText = this.getDefault("CodisclaimerButton");
            this.NdcDetailText = this.getDefault("NDC_details");
            this.GpiDetailText = this.getDefault("GPI");
            this.searchPlaceholderNdcText = this.getDefault("search_placeholder_ndc");
            this.searchPlaceholderGpiText = this.getDefault("search_placeholder_gpi");
            this.zoneDescriptionText = this.getDefault("zone_description");
            this.rxwalletText = this.getDefault("go_to_rxwallet_button");
        },

        getRecaptchaSiteKey: function (key) {
            this.recaptchaSiteKey = key;
        },

        getQueryString: function (queryString) {
            this.inputText = queryString;
            if (this.searchOpts.ln === "") {
                this.searchOpts.ln = queryString;
            };
        },

        openDisclaimer: function () {
            this.showDisclaimerModal = true;
            this.disclaimerMsgText = this.getDefault("disclaimer_text");
        },

        /*
         * loadBenefits is a function used to populate the benefits variable
         * This is used to populate the items on the dropdown menu to select a benefit from
         * This function is called once the app is loaded in.
         */
        loadBenefits: function () {
            var me = this;
            Benefit.get().then(function (res) {
                me.benefits = res.data;
                console.log(me.benefits)
                if (me.benefits[0].FormularyIdentifier == 'publicCCOT5_24' || me.benefits[0].FormularyIdentifier == 'publicCCOT4_24' || me.benefits[0].FormularyIdentifier == 'P5A23015_24' || me.benefits[0].FormularyIdentifier == 'P5A23015_24CO') {           
                    me.showCoDisclaimerModal = true
                }
                me.searchOpts.benefitId = me.benefits[0].Id;
                me.loadPricingModes();
            });
        },

        /*
         * loadPricingModes is a function used to populate the different pricing modes based off of the benefit
         * This function is called once the app has been loaded and the benefits have been loaded.
         */
        loadPricingModes: function () {
            var me = this;
            var int_id = parseInt(me.searchOpts.benefitId);
            for (var i = 0; i < this.benefits.length; i++) {
                if (int_id === parseInt(this.benefits[i].Id)) {
                    globalStore.updateItem(this.benefits[i].Name);
                    globalStore.$forceUpdate();
                    break;
                }
            }

            PricingMode.query(me.searchOpts.benefitId).then(function (res) {
                me.pricingModes = res.data;
                console.log("pricingMode", me.pricingModes);
                me.searchOpts.pricingMode = me.pricingModes[0];
                me.updateDaysSupply();
                console.log("searchOpts", me.searchOpts);
                console.log("benefits", me.benefits);
                if (me.searchOpts.ln && me.searchOpts.ln.length != "") {
                    me.searchClicked();
                }
                if (me.searchOpts.ndc && me.searchOpts.ndc.length != "") {
                    me.searchClicked();
                }
                if (me.searchOpts.gpi && me.searchOpts.gpi.length != "") {
                    me.searchClicked();
                }
            });
        },

        /*
         * clearClicked is a function that is used to reset the state and remove results.
         * This function will also close the panel and announcements.
         * This function is called when a user clicks on the clear button from the drug search
         */
        clearClicked: function () {
            this.results = null;
            this.resultGroups = {};
            this.closePanelClick();
            this.closeAnnouncementClick();
        },

        /*
         * displayBenefitInformation is a function to check whether or not to display the cost on the slideout.
         * If the indicator has a custom text solution then, the information should not display and return false.
         */
        displayBenefitInformation: function (currentResult) {
            if (currentResult.Price.MemberCost === "$0.00") {
                return true;
            }

            if (currentResult.Price.MemberCost === "Plus_Difference") {
                return true;
            }

            if (typeof (currentResult.Price.MemberCost) === "string" && currentResult.Price.MemberCost != "Plus_Difference") {
                return false;
            }

            if (currentResult.TierOverridden && currentResult.Price.MemberCost != "Plus_Difference") {
                return false;
            }
            return true;
        },


        /*
         * displayAllowedAmount is a function to check whether or not to display the cost on the slideout.
         * If the indicator has a custom text solution then, the information should not display and return false.
         */
        displayPlanPaid: function (currentResult) {
            if (typeof (currentResult.Price.MemberCost) === "string") {
                return false;
            }

            if (currentResult.TierOverridden) {
                return false;
            }

            if (this.currentHealthPlanId != 73) {
                return false
            }

            return true;
        },

        /*
 * displayAllowedAmount is a function to check whether or not to display the cost on the slideout.
 * If the indicator has a custom text solution then, the information should not display and return false.
 */
        displayAllowedAmount: function (currentResult) {
            if (currentResult.Price.MemberCost === "$0.00") {
                return false;
            }

            if (typeof (currentResult.Price.MemberCost) === "string") {
                return false;
            }

            if (currentResult.TierOverridden) {
                return false;
            }
            return true;
        },

        /*
         * applyCustomIndicatorLogic is a function that should be implemented depending on the client.
         * Each indicator type will have a different functionality and should be implemented according so.
         * Display type 2 will override the member cost column and not tiers
         * Display type 3 will override cost, tier, and tier descriptions.
         * All custom indicator logic should happen here (overriding columns, setting style, etc.)
         */
        applyCustomIndicatorLogic: function () {
            var me = this;

            // Outer loop for each result type category
            // ex: Preferred Alternatives / Therapeutic Alternatives / Brand Generic Alternatives / Alternative Strengths
            for (var i = 0; i < this.results.length; i++) {

                // Array of drugs with information such as ln, ndc, price, indicators, etc...
                var drugResults = this.results[i]["Results"];

                // Inner loop for each drug lookup result that belongs to the category
                for (var j = 0; j < drugResults.length; j++) {

                    // A drug could have multiple indicators
                    // sort by priority descending, then by suppression (true comes first)
                    var result = drugResults[j],
                        listOfIndicators = result.Indicators.sort(me.compareIndicators);

                    // Loop through each indicator
                    for (var k = 0; k < listOfIndicators.length; k++) {
                        var indicator = listOfIndicators[k];
                        // filter out duplicate UmRequirements (unique identifier is the Order property)
                        var umRequirements = indicator.UmRequirements;
                        //  console.log(umRequirements);
                        for (var l = 0; l < umRequirements.length; l++) {
                            if (umRequirements[l].LinkUrl != null && umRequirements[l].LinkUrl.includes("Requirements?ln=")) {
                                umRequirements[l].LinkUrl = Apollo.resolveAppUrl(umRequirements[l].LinkUrl) + "&benefitId=" + me.searchOpts.benefitId;
                            }
                        }
                        var ids = umRequirements.map(o => o.Order);
                        var uniqueUmRequirements = umRequirements.filter(({ Order }, index) => !ids.includes(Order, index + 1));
                        this.results[i]["Results"][j].Indicators[k].UmRequirements = uniqueUmRequirements;

                        //here might be better for link updates


                        // update result row with indicator (column overrides, etc.)
                        me.updateResult(result, indicator);

                        // Check if an indicator will suppress everything else
                        if (indicator.Suppression) {
                            // if so, eliminate all other indicators
                            result.Indicators = [indicator];
                            break;
                        }
                        else {
                            // We do not suppress other indicators
                            me.updateResult(me.results[i].Results[j], indicator);
                        }
                    }
                }
            }
        },

        /* 
         * Updates the result row's properties using the specified indicator.
         * 
         * @param {Object} result - A drug lookup result row
         * @param {Object} indicator - An indicator
         * 
         */
        updateResult: function (result, indicator) {
            //its a little dirty but I think this is the place to slap the SH logic

            if (indicator.DisplayTypeId === 2) {
                // Override the price column
                result.Price.MemberCost = indicator.DisplayText;
                result.IsLink = false;
            }
            else if (indicator.DisplayTypeId === 3) {
                // Override the price and tier columns
                /*result.Price.MemberCost = indicator.IndicatorCode;
                result.Tier.Tier = indicator.IndicatorCode;
                result.Tier.TierName = indicator.DisplayText;
                result.Tier.TierDescription = indicator.DescriptionEnglish;*/
                result.TierOverridden = true;
                result.Price.MemberCostOverride = indicator.IndicatorCode;
                result.Tier.TierOverride = indicator.IndicatorCode;
                result.Tier.TierNameOverride = indicator.DisplayText;
                result.Tier.TierDescriptionOverride = indicator.DescriptionEnglish;
                result.IsLink = false;
            }
        },

        /* 
         * Compares indicators, returning the sort order -- for use with Array.sort().
         * 
         * @param {Object} a - An indicator
         * @param {Object} b - An indicator
         * 
         * @return {number} Integer indicating sort order.
         */
        compareIndicators: function (a, b) {
            // sort by priority descending
            if (a.Priority != b.Priority) {
                return b.Priority - a.Priority;
            }

            // then by suppression (true comes first)
            if (a.Suppression != b.Suppression) {
                return a.Suppression > b.Suppression ? -1 : 1;
            }

            // then by display type ID descending
            if (a.DisplayTypeId != b.DisplayTypeId) {
                return b.DisplayTypeId - a.DisplayTypeId
            }

            // sort by code if everything else is the same
            return a.IndicatorCode < b.IndicatorCode ? -1 : 1;
        },

        /*
         * searchClicked is a function used to retrieve results for the drug lookup based on what is entered in the search box
         * When a user selects an item from the autocomplete, this function will be called to search for drugs.
         */
        searchClicked: function () {
            var me = this;
            this.closePanelClick();
            this.closeAnnouncementClick();
            var isPublicSearch = window.location.href.search(/\/public\/drugsearch$/i) > 0;

            if (isPublicSearch) {
                grecaptcha.ready(function () {
                    grecaptcha.execute(me.recaptchaSiteKey, { action: "PublicDrugSearch" }).then(function (token) {
                        me.drugSearch(token);
                    });
                });
            } else {
                me.drugSearch(undefined);
            }
        },

        drugSearch: function (token) {
            var me = this;

            const loadingComponent = this.$buefy.loading.open({
                container: true ? null : me.$refs.element.$el
            })

            DrugSearch.search(me.searchOpts.ln, me.searchOpts.ndc, me.searchOpts.gpi, me.searchOpts.pricingMode, me.searchOpts.benefitId, token)
                .then(function (res) {
                    //see if the health plan has anything to say
                    me.findAnnouncements(me.searchOpts.ln);

                    // Data Grouped by the server
                    me.columnHeaders.pricingMode = me.searchOpts.pricingMode.DisplayName;
                    me.columnHeaders.pricingModeCompare = me.searchOpts.pricingModeCompare.DisplayName;

                    me.results = res.data.sort(function (a, b) {
                        return a.ResultType.Sort - b.ResultType.Sort;
                    });
                    me.results.forEach(function (item, index, ar) {
                        me.resultGroups[item.ResultType.Sort.toString()] = item;
                    });
                    me.resultGroups[1].healthplanid = me.currentHealthPlanId;
                    me.resultGroups[2].healthplanid = me.currentHealthPlanId;
                    me.resultGroups[3].healthplanid = me.currentHealthPlanId;
                    me.resultGroups[4].healthplanid = me.currentHealthPlanId;
                    me.applyFilters();

                    me.applyCustomIndicatorLogic();

                    loadingComponent.close();
                }).catch(function (error) {
                    // handle error
                    console.log(error);
                    console.log(error.response);

                    var exceptionMessage;
                    var userMessage;

                    if (error.response) {
                        exceptionMessage = me.getInnermostExceptionMessage(error.response.data);
                    }

                    // can add more specific error messages later
                    switch (exceptionMessage) {
                        case "The wait operation timed out":
                            userMessage = me.searchTimeoutErrorText;
                            break;
                        default:
                            userMessage = me.searchUnknownErrorText;
                    }

                    me.$buefy.toast.open({
                        message: userMessage,
                        type: "is-danger",
                        duration: 5000
                    });

                    loadingComponent.close();
                })
                .then(function () {
                    // always executed and reset sort if user didnt clear previous results
                    if (me) {
                        me.$refs.maintable.$refs.headers.currentSortColumn = {};
                    }
                });
        },

        getInnermostExceptionMessage: function (exceptionData) {
            console.log(exceptionData.InnerException);
            return (exceptionData.InnerException) ? this.getInnermostExceptionMessage(exceptionData.InnerException) : exceptionData.ExceptionMessage;
        },

        /*
         * applyFilters is a function used to filter out drug lookup results to either covered or generic drugs
         * This function is called when a user toggles the switches under the search bar
         */
        applyFilters: function () {
            var me = this;
            Object.keys(this.resultGroups).forEach(function (item) {
                me.resultGroups[item].ResultsFiltered = me.resultGroups[item].Results;
                // 0 Copay and not covered: price to string message
                me.resultGroups[item].ResultsFiltered = me.resultGroups[item].ResultsFiltered.filter(me.filterZeroCopay);
                if (me.coveredOnly) {
                    me.resultGroups[item].ResultsFiltered = me.resultGroups[item].ResultsFiltered.filter(me.filterCoveredOnly);
                }
                if (me.genericsOnly) {
                    me.resultGroups[item].ResultsFiltered = me.resultGroups[item].ResultsFiltered.filter(me.filterGenericsOnly);
                }
            });
            this.closePanelClick();
            if (this.$refs.maintable) {
                this.$refs.maintable.updateTableData();
                this.tableKey += 1;
            }
            me.currentResult = null;
        },

        /*
         * findAnnouncements is a function that will show announcements for a certain drug if there are any
         * This function is called each time a drug is searched and will have a small pop up for the announcement if there are any.
         * @param drugName
         */
        findAnnouncements: function (drugName) {
            var me = this;
            Announcement.findAnnouncement({
                ln: drugName
            }).then(function (response) {
                if (response.data.length > 0) {
                    me.currentAnnouncement = response.data[0];
                    me.state.announcementOpen = true;
                }
            });
        },

        /*
         * updateDaysSupply is a function used to retrieve the correct days supply based on the pricing mode.
         * This function is called each time a drug search is performed.
         */
        updateDaysSupply: function () {
            var benefit = this.benefits.find(obj => {
                return obj.Id === this.searchOpts.benefitId;
            })

            var zone = benefit.Zones.find(obj => {
                return obj.ZoneNbr === this.searchOpts.pricingMode.Zone;
            })
            if (this.searchOpts.pricingMode == null) {
                this.daysSupply = zone.MaxDaysRetail;
            } else {
                switch (this.searchOpts.pricingMode.RetailMailStatus) {
                    case 1:
                        this.searchOpts.daysSupply = zone.MaxDaysRetail;
                        break;
                    case 2:
                        this.searchOpts.daysSupply = zone.MaxDaysMail;
                        break;
                    default:
                        this.searchOpts.daysSupply = "30";
                        break;
                }
                if (this.searchOpts.daysSupply == undefined || this.searchOpts.daysSupply == null) {
                    this.searchOpts.daysSupply = "30";
                }
                if (this.searchOpts.ln && this.searchOpts.ln.length != "") {
                    this.searchClicked();
                }
                if (this.searchOpts.ndc && this.searchOpts.ndc.length != "") {
                    this.searchClicked();
                }
                if ( this.searchOpts.gpi && this.searchOpts.gpi.length != "") {
                    this.searchClicked();
                }
            }
        },

        /*
         * resultClick is a function that handles the click event when a user clicks on a row from the drug search results table
         * This function will set all the variables to the clicked drug's information.
         * The function will also open the slideout panel to reveal additional information about it.
         * @param result is the drug that the user clicked from the table.
         */
        resultClick: function (result) {
            this.addDrugForm = false;
            this.$refs.slideOut.open();
            this.$refs.slideOut.isFlipped = false;
            this.currentResult = result;

            axios.post(Apollo.resolveApiUrl("~/log/info"), {
                "location": "Drug Search",
                "message": "Drug result clicked"
            });
        },

        /*
         * getCustomPriceDescription is a function used to handle custom indicator's price description.
         * This function will set the result's price description to the corresponding value in the table.
         * @param tierName the tiername is actually the indicator that needs to have a custom description.
         * @param result the drug result object that has the price description property
         */
        getCustomPriceDescription: function (tierName, result) {
            if (tierName in this.customPriceDescription) {
                result.Price.PriceDescription = this.customPriceDescription[tierName];
            }
            return result;
        },

        /* Returns true if quantity information should be shown for the drug search result.
         * 
         * @return {boolean} Whether or not quantity information should be shown.
         * 
         */
        showQuantity: function (result) {
            // hide quantity for results with an indicator that override tier and price
            let indicator = result.Indicators.find(x => x.DisplayTypeId === 3);
            return !indicator;
        },

        /*
         * autocompleteSelected is a function that is called when a user selects an item from the autocomplete drop down menu
         * When a user selects an item, a drug search will be performed based on the value selected
         * @param data is the item that the user has selected.
         */
        autocompleteSelected: function (data) {
            if (data != null) {
                this.searchOpts.ln = data.trim();
                this.searchOpts.ndc = null;
                this.searchOpts.gpi = null;
                this.searchClicked();
            }
        },

        autocompleteSelectedLn: function (data) {
            if (data != null) {
                this.searchOpts.ln = data.trim();
                this.searchOpts.ndc = null;
                this.searchOpts.gpi = null;
                this.searchClicked();
            }
        },

        autocompleteSelectedNdc: function (data) {
            if (data != null) {
                this.searchOpts.ndc = data.trim();
                this.searchOpts.gpi = null;
                this.searchClicked();
            }
        },

        autocompleteSelectedGpi: function (data) {
            if (data != null) {
                this.searchOpts.gpi = data.trim();
                this.searchOpts.ndc = null;
                this.searchClicked();
            }
        },

        /*
         * addCabinetFlip is a function that is called when a user clicks on the add medication button from the slideout panel
         * This will open the cabinet form for the user to fillout with details of the drug
         * This will also initialize the needed variables in order to add a drug to the cabinet.
         */
        addCabinetFlip: function () {
            this.currentResult.FillDate = Date.now();
            this.currentResult.Labels = this.labels;
            this.currentResult.Source = 1;
            this.addDrugForm = true;
            this.$refs.slideOut.isFlipped = !this.$refs.slideOut.isFlipped;
        },

        /*
         * flipClick is a function that is used to toggle the state of the slide out panel
         * This function is called when the user clicks on the result detail button on the slideout
         */
        flipClick: function () {
            this.addDrugForm = false;
            this.$refs.slideOut.isFlipped = !this.$refs.slideOut.isFlipped;

            if (this.$refs.slideOut.isFlipped) {
                axios.post(Apollo.resolveApiUrl("~/log/info"), {
                    "location": "Drug Search",
                    "message": "Medication Information button clicked"
                });
            }
        },

        /*
         * closePanelClick is a function that will close the slideout panel
         * This function is bound to the x button in the top right corner when the panel is open.
         */
        closePanelClick: function () {
            this.$refs.slideOut.close();
            var me = this;
            setTimeout(function () {
                me.currentResult = null;
                me.$refs.slideOut.isFlipped = false;
                if (me.$refs.maintable) {
                    me.$refs.maintable.clearCurrentResult();
                }
            }, 250);
        },

        /*
         * closeAnnouncementClick is a function that will close the announcement if it is currently open.
         * This function is bounded to the close button on the announcement component.
         */
        closeAnnouncementClick: function () {
            this.state.announcementOpen = false;
            Announcement.optOutOfAnnouncement(
                this.currentAnnouncement.AnnouncementId
            );
        },

        /*
         * checkIndicatorCode is a function that checks to see if a drug has the indicator code
         * @param indicators the list of indicators
         * @code the indicator code to check for
         */
        checkIndicatorCode: function (indicators, code) {
            var found = false;
            indicators.forEach(function (cIndicator) {
                if (cIndicator.IndicatorCode == code) {
                    found = true;
                    return;
                }
            });
            return found;
        },

        /*
         * filterGenericsOnly is a  function thatfilters a list of drugs to only return the ones that are generic
         */
        filterGenericsOnly: function (r) {
            return r.IsGeneric;
        },

        /*
         * filterCoveredOnly is a function that filters a list of drugs to only return the ones that are generic
         */
        filterCoveredOnly: function (r) {
            return r.Tier.Tier != 0;
        },

        /*
         * filterZeroCopay is a function that will apply filters to check if the drug is not covered or a medical benefit.
         * This is dependent on if Tier 0 is truly a not covered status
         * Like how the Medical Benefit drugs are also tier 0 is a seperation from the this
         */
        filterZeroCopay: function (r) {
            /*
            if (r.Tier.Tier == "0" && r.Tier.TierName == "Not Covered" && !(this.checkIndicatorCode(r.Indicators, 'MB')) && !(this.checkIndicatorCode(r.Indicators, 'MBPA'))) {
                r.Price.PriceName = "NC";
                r.Indicators = [];
            } else if (r.Tier.Tier == "0" && r.Tier.TierName == "Not Covered" && this.checkIndicatorCode(r.Indicators, 'MB')) {
                r.Price.PriceName = "Medical Benefit";
                r.Tier.TierName = "Medical Benefit";
            }
            */
            return r;
        },

        /*
        * preformQuantityDrugSearch is a function that redirects the user to a new page
        * The new page is used to search specific quantity pricing
        */
        GoToRxWallet() {
            var location = Apollo.resolveAppUrl('~/clavis/rxwallet/')
            window.open(location,'_blank' );
        },
        
        preformQuantityDrugSearch: function (ln, pricingMode, benefitId) {
            this.drugSearchClicked = true;
            pricingMode = this.searchOpts.pricingMode.DisplayName
            window.location.href = Apollo.resolveAppUrl('~/quantitysearch') + "?ln=" + encodeURIComponent(ln) + "&pricingMode=" + encodeURIComponent(pricingMode) + "&benefitId=" + encodeURIComponent(benefitId);
        },

        preformPublicQuantityDrugSearch: function (ln, pricingMode, benefitId) {
            this.drugSearchClicked = true;
            pricingMode = this.searchOpts.pricingMode.DisplayName
            window.location.href = Apollo.resolveAppUrl('~/public/QuantitySearch') + "?ln=" + encodeURIComponent(ln) + "&pricingMode=" + encodeURIComponent(pricingMode) + "&benefitId=" + encodeURIComponent(benefitId)
        },

        RealTimeBenefitCheck: function (ln, pricingMode, benefitId) {
            this.drugSearchClicked = true;
            pricingMode = this.searchOpts.pricingMode.DisplayName
            window.location.href = Apollo.resolveAppUrl('~/PriceCheck') + "?ln=" + encodeURIComponent(ln) + "&pricingMode=" + encodeURIComponent(pricingMode) + "&benefitId=" + encodeURIComponent(benefitId)
        },
        closePopUpReset: function () {
            this.showCoDisclaimerModal = false;
        },

        updateParent(value_from_child) {
            this.searchOpts.searchoptionspicked = value_from_child;
            this.updateAutocomplete();
        },

        updateAutocomplete: function () {
            if (this.searchOpts.searchoptionspicked == 1) {
                this.ndcSearchSelected = false
                this.gpiSearchSelected = false
                this.lnSearchSelected = true
            } else if (this.searchOpts.searchoptionspicked == 2) {
                this.ndcSearchSelected = true
                this.gpiSearchSelected = false
                this.lnSearchSelected = false
            } else if (this.searchOpts.searchoptionspicked == 3) {
                this.ndcSearchSelected = false
                this.gpiSearchSelected = true
                this.lnSearchSelected = false
            }
        },


        /*
         * getAutocompleteData is a function that populates the autocomplete drop down in the search bar
         * This will call the api to retrieve drugs with names that start with the same input.
         * @param name is the input value that the user is currently typing.
         */
        getAutocompleteData: debounce(function (name) {
            if (!name.length) {
                this.autocompleteSource = [];
                return;
            }
            var me = this;
            this.$http.get(Apollo.resolveApiUrl('~/autocomplete/drugsearch'), {
                params: {
                    'q': name
                }
            })
                .then(({
                    data
                }) => {
                    me.autocompleteSource = [];
                    data.forEach((item) => me.autocompleteSource.push(item.Name));
                })
                .catch((error) => {
                    me.autocompleteSource = [];
                    throw error;
                })
                .finally(() => { })
        }, 750),
        getAutocompleteDataNDC: debounce(function (name) {
            if (!name.length) {
                this.autocompleteSource = [];
                return;
            }
            var me = this;
            this.$http.get(Apollo.resolveApiUrl('~/autocomplete/drugsearch/NDC'), {
                params: {
                    'q': name
                }
            })
                .then(({
                    data
                }) => {
                    me.autocompleteSource = [];
                    data.forEach((item) => me.autocompleteSource.push(item.Name));
                })
                .catch((error) => {
                    me.autocompleteSource = [];
                    throw error;
                })
                .finally(() => { })
        }, 750),
        getAutocompleteDataGpi: debounce(function (name) {
            if (!name.length) {
                this.autocompleteSource = [];
                return;
            }
            var me = this;
            this.$http.get(Apollo.resolveApiUrl('~/autocomplete/drugsearch/GPI'), {
                params: {
                    'q': name
                }
            })
                .then(({
                    data
                }) => {
                    me.autocompleteSource = [];
                    data.forEach((item) => me.autocompleteSource.push(item.Name));
                })
                .catch((error) => {
                    me.autocompleteSource = [];
                    throw error;
                })
                .finally(() => { })
        }, 750),
    },
    filters: {

        currency: function (v) {
            if (v == null) {
                return "";
            }
            if (typeof (v) === "string") {
                return v;
            }
            return "$" + v.toFixed(2);

        },

        defaultReplace: function (v, str) {
            return str ? str.replace("{0}", v) : "";
        }

    },
    created: function () {
        this.searchOpts.pricingModeCompare = this.pricingModeNone;
    },

    mounted: function () {
        var me = this;

        Account.getUser().then(function (response) {
            me.user = response.data;
            me.hasMemberServices = me.user.Roles.includes("member_services");

        }).catch(function (error) {
            console.log(error);
        }); 
    },

    data: {
        checkPharmacyText: "",
        isEmulated: false,
        hasMemberServices: false,
        tableKey:0,
        primaryPersonId: "",
        currentPersonId: "",
        defaults: [],
        searchPlaceholderText: "",
        searchButtonText: "",
        clearButtonText: "",
        noResultsText: "",
        disclaimerMsgText: "",
        daysSupplyUpToText: "",
        coveredOnlyText: "",
        genericsOnlyText: "",
        benefitOnlyText: "",
        indicatorsText: "",
        quantityText: "",
        quantityDesc1Text: "",
        quantityDesc2Text: "",
        quantityDesc3Text: "",
        quantityLinkText: "",
        alternativesInformationText: "",
        addCabinetText: "",
        medInfoText: "",
        resultDetailText: "",
        disclaimerText: "",
        searchTimeoutErrorText: "",
        searchUnknownErrorText: "",
        proTipText: "",
        proTipMessageText: "",
        allowedAmountText: "",
        maintenanceText: "",
        planPaidText: "",
        tableDefaults: [],
        localvar: globalStore,
        pricingModes: [],
        autocompleteSource: [],
        benefits: [],
        formulary: "Formulary",
        showDisclaimerModal: false,
        customHeaders: headers,
        pricingModeNone: {
            Zone: -1,
            RetailMailStatus: 1
        },
        /*
        overRideHashSet: {
            "Medical Benefit": true,
            "No Copay": true,
            "Contact SelectHealth": true,
            "Home Infusion": true,
            "Not Covered": true,
            "NC": true,
            "MBPA": true
        },
        overRideQuantityHashSet: {
            "Not Covered": true,
            "NC": true,
            "Medical Benefit": true
        },
        customPriceDescription: {
            "Not Covered": "This drug is not covered by your benefit."
        },
        */
        searchOpts: {
            ln: "",
            ndc: "",
            gpi: "",
            pricingMode: null,
            pricingModeCompare: null,
            quantity: "30",
            daysSupply: "30",
            customQuantity: null,
            customDaysSupply: null,
            benefitId: null
        },
        resultGroups: {},
        state: {
            announcementOpen: false
        },
        optionsCollapsed: true,
        results: null,
        currentHealthPlanId: null,
        labels: [],
        currentAnnouncement: {},
        currentResult: null,
        genericsOnly: false,
        coveredOnly: true,
        addDrugForm: false,
        showPriceCompare: false,
        columnHeaders: {
            pricingMode: null,
            pricingModeCompare: null
        },
        autocompleteUrl: Apollo.resolveApiUrl('~/autocomplete/drugsearch'),
        recaptchaSiteKey: "",
        queryString: "",
        inputText: "",
        drugSearchClicked: false,
        checkPriceFlag: false,
        proTipPublicText: "",
        proTipPublicMessageText: "",
        showCoDisclaimerModal: false,
        CoDisclaimerModalTitleText: "",
        CoDisclaimerModalMessageText: "",
        CoDisclaimerModalButtonText: "",
        NdcDetailText: "",
        GpiDetailText: "",
        searchPlaceholderNdcText: "",
        searchPlaceholderGpiText: "",
        zoneDescriptionText: "",
        rxwalletText: "",
        ndcSearchSelected: false,
        gpiSearchSelected: false,
        lnSearchSelected: true,
        RxWalletSSO: false,
        TrueRxWalletSSO: false
    }
});

app.setEmulationStatus();
app.loadDefaults();
app.loadBenefits();





// WEBPACK FOOTER //
// ./src/apps/DrugSearchApp.js